export default __webpack_public_path__ + "static/media/mercadopago-logo.2de0453b.png";